import { render } from "./Block.vue?vue&type=template&id=04a67c1d"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"

import "./Block.vue?vue&type=style&index=0&id=04a67c1d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__